import React, {useEffect, useState } from "react";
import {  getTask, updateTask, approveTask, disapproveTask, getLoggedInUser } from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { useParams, useHistory } from "react-router-dom";
import { alertError, alertSuccess } from "../../utils/alerts";

const INIT_STATE = {
    task_title: "",
    task_kpi: "",
    task_description: "",
    status: "",
    task_deadline: "",
    assigned_to: "",
};

export default function ViewTask() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState(INIT_STATE);
    const [task, setTask] = useState(null);
    const [profile, setProfile] = useState("");

    useEffect(() => {
        getTask(id)
            .then((res) => { 
                if(res.data.success){
                    setTask(res.data.data);  
                    setLoading(false)
                }
            })
            .catch((err) => { 
                setLoading(false)
                console.log(err.response)
            });
    }, [id]);

    const TOKEN = localStorage.getItem("kloka:token:data");

    useEffect(()=>{
        getLoggedInUser(TOKEN).then((res) => {
            setProfile(res.data.data);
        });
    },[TOKEN]);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            task_title: (task && task.task_title) || "",
            task_project: (task && task.task_project) || "",
            task_kpi: (task && task.task_kpi) || "",
            status: (task && task.status) || "",
            task_description: (task && task.task_description) || "",
            team: (task && task.team) || "",
            task_deadline: (task && task.task_deadline) || "",
            date: (task && task.date) || "",
            assigned_to: (task && task.assigned_to) || "",
        }));
    }, [task]);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const isCanEdit = task ? task.status && (task.assigned_to?._id === profile._id) && (task.status === "not started" || task.status === "in progress") : false;

    const isTeamHead = (task && task.team?.team_head) ? task.team?.team_head === profile._id : false;

    const handleSave = async (e) => {
        e.preventDefault();
        const data = {
            ...state,
            id
        }
        if(data.task_deadline && data.task_title){
            setLoading(true);
            updateTask(data, id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    history.goBack();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                    setLoading(false);
                });
        }
    };

    const handleApprove = async (e) => {
        e.preventDefault();
        if(id){
            setLoading(true);
            approveTask(id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    history.goBack();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                    setLoading(false);
                });
        }
    };

    const handleDisapprove = async (e) => {
        e.preventDefault();
        if(id){
            setLoading(true);
            disapproveTask(id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    history.goBack();
                })
                .catch((err) => {
                    alertError(err.response.data.error);
                    setLoading(false);
                });
        }
    };

    return (
        <>  
            {/* {!loading && kpd ? 
            <div className="spur-card-menu">
                <button type="button" data-toggle="modal" data-target="#modal" className="pull-right btn topbtn btn-primary">ADD KPI</button>
            </div> : null } */}

            <h1 className="dash-title"><Link to="/performance/tasks" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">View Task</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {!loading && task ? <>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Employee: <span>*</span></label>
                                            <input name="employee" type="text" placeholder="Employee" className="form-control" required 
                                            defaultValue={state.assigned_to?.first_name} disabled />
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Team: <span>*</span></label>
                                            <input name="team" type="text" placeholder="Team" className="form-control" required 
                                            defaultValue={state.team?.team_name || ""} disabled />
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Related KPI: <span>*</span></label>
                                            <input name="task_kpi" type="text" placeholder="Related KPI" className="form-control" required 
                                                defaultValue={(state.task_kpi?.kpi && state?.task_kpi?.kpi) || ""} disabled />
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Title: <span>*</span></label>
                                            <input name="task_title" type="text" placeholder="Task Title" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.task_title && state.task_title} disabled={!isCanEdit} />
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Deadline: <span>*</span></label>
                                            <input name="task_deadline" type="date" placeholder="Task Deadline" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.task_deadline && state.task_deadline} disabled={!isCanEdit} />
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Status: <span>*</span></label>
                                            <select className="form-control form-select" name="status" id="status" required  
                                            onChange={handleChange} defaultValue={state.status} disabled={!isCanEdit}>
                                                <option value=''>Select Status</option>
                                                <option value="not started">Not Started</option>
                                                <option value="in progress">In Progress</option>
                                                <option value="finished">Finished</option>
                                                <option value="reassigned">Reassigned</option>
                                            </select>
                                        </div>
                                        <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Description: <span>*</span></label>
                                            <textarea name="task_description" cols="33" rows="4" placeholder="Task Description" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.task_description} disabled={!isCanEdit} ></textarea>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {isCanEdit ? (
                                            <div className="col-md-12 col-sm-12 text-center">
                                                <button 
                                                    type="submit" 
                                                    className="btn btn-primary" 
                                                    disabled={loading}
                                                    onClick={handleSave} >UPDATE TASK</button>
                                                </div>
                                        ) : null}

                                        {(isTeamHead && task.status === "finished") ? (
                                            <div className="col-md-12 col-sm-12 text-center">
                                                <div className="btn-group">
                                                    <button 
                                                        type="submit" 
                                                        className="btn btn-success" 
                                                        disabled={loading}
                                                        onClick={handleApprove}>
                                                            APPROVE TASK
                                                        </button>
                                                    </div>
                                                    <button 
                                                        type="submit" 
                                                        className="btn btn-danger" 
                                                        disabled={loading}
                                                        onClick={handleDisapprove} >
                                                            DISAPPROVE TASK
                                                    </button>
                                                </div>
                                        ) : null}
                                    </div>
                                </> :  <Loader /> }
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </>
    );
}
